module.exports = __webpack_public_path__ + "static/media/star-half.338abbf5.svg";